<template>
  <main class="">
    <div class="table-container">
      <MembersTable
        v-if="dealroomMembers && dealroomMembers.length !== 0"
        :tableHeaders="tableHeaders"
        :tableRows="tableRows"
        :columnNumber="tableHeaders.length - 2"
        :columnWidth="200"
        :totalPage="pages"
        :currentPage="page"
        :deals="tokens"
        @gotoPage="gotoPage"
        :showPagination="false"
        @update-members="fetchDealRoomMembers({ page, status })"
      />
      <EmptyState v-if="!dealroomMembers || dealroomMembers.length === 0">
        <template v-slot:message>
          <div class="tw-text-center tw-text-gray tw-my-3">
            <p>There are no members on this account.</p>
            <!-- <p v-if="status === 'All members'">
              There are no members on this account.
            </p> -->
            <!-- <p v-if="status === 'Waitlist'">
              There are no pending members on this account.
            </p>
            <p v-if="status === 'Inactive'">
              There are no deactivated members on this account.
            </p> -->
          </div>
        </template>
      </EmptyState>
      <!-- <div v-if="searchLoading" class="tw-bg-white tw-h-52">
        <Loader v-if="searchLoading" />
      </div> -->
    </div>
  </main>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import MembersTable from "@/components/tables/MembersTable";
  import EmptyState from "@/components/notification/EmptyState";
  import { formatISOTime, formatISODate, truncate } from "@/utils/helpers.js";
  export default {
    name: "Members",
    data() {
      return {
        tableHeaders: [
          "Name",
          "Email",
          "Phone Number",
          "Date Joined",
          "Status",
          "Action",
          "id",
        ],
        tableRows: [],
        page: 1,
        pages: 0,
      };
    },
    components: { MembersTable, EmptyState },
    computed: {
      ...mapGetters("TokenModule", ["dealroomMembers"]),
      ...mapGetters("organisationModule", ["tokens"]),
    },
    created() {
      this.fetchDealRoomMembers();
    },
    watch: {
      dealroomMembers: "updateTableRow",
    },
    methods: {
      ...mapActions("TokenModule", ["getDealRoomMembers"]),
      async fetchDealRoomMembers(query = { page: 1, limit: 10 }) {
        try {
          const response = await this.getDealRoomMembers(query);
          const { page, pages } = response.data.data;
          this.page = page;
          this.pages = pages;
        } catch (error) {
          return error;
        }
      },

      updateTableRow() {
        this.tableRows = this.dealroomMembers?.map((member) => {
          let name = "";
          let status = member.status;
          switch (status) {
            case "Inactive":
              status = "Deactivated";
              break;

            case "Pending_Approval":
              status = "Pending";
              break;
            default:
              break;
          }
          if (status == "Pending") {
            name = member.name;
          } else {
            name = `${member.user ? member.user.fname : member.fname} ${
              member.user ? member.user.lname : member.lname
            }`;
          }
          return {
            name: `<span class="tw-font-bold">${name}</span>`,
            email: truncate(
              member.user?.email ? member.user?.email : member.email,
              25
            ),
            phone: ` <a href="tel:+${member.user?.phone}">${
              member.user?.phone || "------"
            }</a>`,
            joined: `${formatISODate(
              member.createdAt || member.date_joined
            )}  ${formatISOTime(member.createdAt || member.date_joined)}`,
            id: `data-id/${member.member_id ? member.member_id : member._id}/${
              member.user ? member.user._id : member._id
            }`,
            status: status,
          };
        });
      },

      gotoPage(page) {
        const query = { page: page, status: "" };
        this.fetchDealRoomMembers(query);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .table-container {
    overflow: auto;
  }
</style>
